import { displayUserAddressMap } from "../../common/functions/others";

const initializeDisplayGoogleMap = () => {
  if (document.querySelector("#jsGoogleMap")) {
    const data = document.querySelector("#jsGoogleMap");
    $.ajax({
      url: Routes.async_info_user_google_maps_path(data.dataset.user),
      type: "GET",
      success: (json) => {
        displayUserAddressMap(json.location_lat, json.location_lng);
      },
      error: (_XMLHttpRequest, _textStatus, _errorThrown) => {
        console.log("errorです");
      },
    });
  }
};

// NOTE: esbuild はモジュールレベルの副作用がない純粋な関数宣言をバンドルから除外する
// Sprockets からの移行のため、グローバルアクセスを維持するために window に公開する

export default initializeDisplayGoogleMap;
